(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/teammatches/assets/javascripts/views/statteammatches.js') >= 0) return;  svs.modules.push('/components/statistics/teammatches/assets/javascripts/views/statteammatches.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  svs.statistics.views.StatTeamMatches = svs.statistics.views.StatBase.extend({
    tagName: 'div',
    classId: 'StatTeamMatches',
    statisticsMini: {},
    events: {
      'change #matchesMonthFilter':
        'selectMenu' 
    },
    initialize: function(options) {
      this.matchesViews = [];

      if (this.options.params && _.has(this.options.params, 'bigNavRef')) {
        this.bigNavRef = this.options.params.bigNavRef;
      }

      if (!options.params.teamId) {
        return;
      }

      this.model = new svs.statistics.models.StatTeamMatches({
        teamId: this.options.params.teamId
      });

      this.filters = {
        matchesMonthFilter: {
          filterValues: {},
          selectedKey: '',
          fallBackState: false
        }
      };

      this.model.on('change', this.render, this);
      if (this.options.params.currentLeagues) {
        this.currentLeaguesModel = this.options.params.currentLeagues;
      } else {
        this.currentLeaguesModel = new svs.statistics.models.CurrentLeagues({
          teamId: this.options.params.teamId
        });
        this.currentLeaguesModel.fetch();
        this.currentLeaguesModel.on('change', this.render, this);
      }

      this.on('resize', this.resize, this);

      if (
        !!(((svs.statistics || {}).data || {}).teamModels || {}).matches &&
        !svs.statistics.data.teamModels.matches.error
      ) {
        this.render(options);
      } else {
        this.update(options);
      }
    },
    update: function() {
      var _self = this;
      if (svs.statistics.data.content) {
        this.model.set(svs.statistics.data.content);
        svs.statistics.data.content = null; 
      } else {
        this.model.fetch({
          error: function() {
            _self.model.matchCollection.reset();
            _self.model.set('fetchError', true, { silent: true });
            _self.model.trigger('change', _self.model);
          },
          success: function() {}
        });
      }
    },
    render: function() {
      var _self = this;

      this.hideLoader();

      if (!this.model) {
        this.$el.html(
          svs.statistics.statistics.templates.nodata({
            renderEmpty: this.options.params.preDraw
          })
        );
        return this;
      }

      if (this.model.get('error') && !this.model.get('fetched')) {
        this.showLoader();
        return this;
      }

      if (this.model.get('fetchError')) {
        this.$el.html(svs.statistics.statistics.templates.tryagain({}));
        this.$('.js-statistics-reload').bind('click', function() {
          $(this).unbind('click');
          _self.model.set('fetchError', false, { silent: true });
          _self.showLoader();
          _self.update();
        });
        return this;
      }

      var date = [];
      this.populateMonthFilter();

      if (
        !_.isEmpty(this.model.matchCollection) &&
        this.model.matchCollection.length > 0
      ) {
        date = this.model.matchCollection.groupBy(function(model) {
          return model.get('displayDate');
        });
      }
      this.$el.html(
        svs.statistics.teammatches.templates.statteammatches({
          matches: date,
          filters: this.filters,
          errorMessage: {
            message:
              'Inga matcher i ' +
              this.filters.matchesMonthFilter.filterValues[
                this.filters.matchesMonthFilter.selectedKey
              ].name
          }
        })
      );

      _.each(date, function(group, index) {
        _.each(group, function(match) {
          var view = new svs.statistics.views.Match({
            modelReference: match,
            templateReference: svs.statistics.teammatches.templates.match,
            index: index,
            subscribe: {
              odds: true,
              draws: true
            }
          });
          _self
            .$('#list-group-' + svs.utils.url.encode(index))
            .append(view.render().el);

          _self.matchesViews.push(view);
        });
      });
      this.resize();
      return this;
    },
    disposeSubviews: function() {
      _.invoke(this.matchesViews, 'destroy');
      this.matchesViews = [];
    },
    populateMonthFilter: function() {
      if (this.filters.matchesMonthFilter.fallBackState) {
        this.filters.matchesMonthFilter.filterValues = {};
        this.filters.matchesMonthFilter.fallBackState = false;
      }

      var startDate,
        endDate,
        dateComplete = false,
        i;
      if (!_.isEmpty(this.filters.matchesMonthFilter.filterValues)) {
        for (i in this.filters.matchesMonthFilter.filterValues) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.filters.matchesMonthFilter.filterValues,
              i
            )
          ) {
            if (!startDate && i !== '0') {
              startDate = moment(i.toString(), 'YYYYMM');
            }
            endDate = moment(i.toString(), 'YYYYMM').add(1, 'd');
          }
        }
      }
      if (
        this.currentLeaguesModel.get('leagues') &&
        this.currentLeaguesModel.get('leagues').length
      ) {
        _.each(this.currentLeaguesModel.get('leagues'), function(league) {
          var seasonStartDate = moment(league.season.startDate),
            seasonEndDate = moment(league.season.endDate);
          if (startDate) {
            startDate = moment.min(seasonStartDate, startDate);
          } else {
            startDate = seasonStartDate;
          }
          if (endDate) {
            endDate = moment.max(seasonEndDate, endDate);
          } else {
            endDate = seasonEndDate;
          }
        });
      }
      if (!!startDate && !!endDate) {
        if (endDate.diff(startDate, 'months') > 6) {
          dateComplete = true;
        }
      }
      if (
        this.model.get('matches') &&
        this.model.get('matches').length &&
        !dateComplete
      ) {
        for (i = 0; i < this.model.get('matches').length; i++) {
          if (this.model.get('matches')[i].league) {
            startDate = moment.min(
              moment(this.model.get('matches')[i].league.season.startDate),
              moment(startDate)
            );
            endDate = moment.max(
              moment(this.model.get('matches')[i].league.season.endDate),
              moment(endDate)
            );
          }
        }
      }
      if (!startDate || !endDate) {
        startDate = moment().startOf('year');
        endDate = moment().endOf('year');
        this.filters.matchesMonthFilter.fallBackState = true;
      }
      this.filters.matchesMonthFilter.filterValues = {};
      this.filters.matchesMonthFilter.filterValues[0] = {
        name: 'Aktuellt',
        selectedName: 'Aktuellt',
        selected: false
      };
      var d = startDate;
      var m;
      while (d.isBefore(endDate)) {
        if (d.month() !== m) {
          m = d.month();
          var monthName = d.format('MMM YYYY');
          monthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);
          this.filters.matchesMonthFilter.filterValues[d.format('YYYYMM')] = {
            name: monthName,
            selected: false
          };
        }
        d.add(1, 'd');
      }
      if (
        !this.filters.matchesMonthFilter.filterValues[
          this.filters.matchesMonthFilter.selectedKey
        ]
      ) {
        this.filters.matchesMonthFilter.selectedKey = 0;
      }
      this.filters.matchesMonthFilter.filterValues[
        this.filters.matchesMonthFilter.selectedKey
      ].selected = true;
    },
    selectMenu: function(event) {
      this.showLoader();
      this.disposeSubviews();
      var selectedVal = $(event.currentTarget).val();

      this.filters[$(event.currentTarget).attr('id')].selectedKey = selectedVal;
      _.each(
        this.filters[$(event.currentTarget).attr('id')].filterValues,
        function(filterValue) {
          filterValue.selected = false;
        }
      );
      this.filters[$(event.currentTarget).attr('id')].filterValues[
        selectedVal
      ].selected = true;

      this.model.setSelection(selectedVal);
    },
    resize: function() {
      if (Object.prototype.hasOwnProperty.call(this.options.params, 'parent')) {
        this.options.params.parent.trigger('resize');
      }
    },
    onDestroy: function() {
      this.off('resize', this.resize);
      this.disposeSubviews();
      this.unbind();
    }
  });
})(Backbone, _, svs);

 })(window);